import { AnyType } from '@src/models/common';
import { getStorageUrl } from './storageUrl';

/**
 *  Функция для получения логотипа продукта, позваляет получить корректный урл обрабатывая `logo` и `newLogo`.
 *  Не забудьте передать в объекте `product` оба этих поля
 *  Функция в первую очередь попытается получить урл из newLogo
 *
 * @param fieldNames поле из объекта `newLogo` урл которого вы хотите получить
 */
export const getProductLogo = (
  product: Partial<{ newLogo?: AnyType; logo: AnyType }>,
  fieldNames: string | string[] = 'previewUrl',
) => {
  let logoUrl = product.logo ? getStorageUrl('product-logo', product.logo) : undefined;

  if (product.newLogo && typeof product.newLogo === 'object') {
    if (typeof fieldNames === 'string') {
      logoUrl = product.newLogo[fieldNames];
    } else if (Array.isArray(fieldNames)) {
      logoUrl = fieldNames.reduce((acc, item) => {
        return acc?.[item];
      }, product.newLogo);
    }
  }

  return logoUrl;
};
